import { z } from "zod";

export const signInSchema = z.object({
  email: z.string().trim().email("Email is required"),
  password: z.string().min(1, "Password is required"),
  rememberMe: z.boolean().optional(),
});

export type SignInFormData = z.infer<typeof signInSchema>;
